export default function UserUploadFileButton() {
    return (
        <i className="icon userFile_icon"/>
    )
}